import React, { useMemo, useState } from 'react';
import Dialog from '../../../../../organisms/Dialog';
import SearchFilter from '../../../../../atoms/SearchFilter';
import { Template } from '../../../../../../types/communication';

interface LinkTemplateDialogProps {
    show: boolean;
    templates: Template[];
    onClose: () => void;
    onLink: (templateId: string) => void;
}

const LinkTemplateDialog: React.FC<LinkTemplateDialogProps> = ({ show, templates, onClose, onLink }) => {
    const [search, setSearch] = useState('');
    const [selected, setSelected] = useState<string | null>(null);

    const filtered = useMemo(() => {
        const term = search.trim().toLocaleLowerCase('pt-BR');
        return templates.filter((t) => !term || `${t.name} ${t.description}`.toLocaleLowerCase('pt-BR').includes(term));
    }, [templates, search]);

    const close = () => {
        setSelected(null);
        setSearch('');
        onClose();
    };

    return (
        <Dialog
            id="link-template"
            show={show}
            onClose={close}
            size="md"
            header="Usar um modelo existente"
            body={
                <div className="flex flex-col gap-3">
                    <p className="text-xs text-gray-500">Um modelo só pode estar em uma composição. Aqui aparecem os que estão livres.</p>
                    <SearchFilter value={search} onChange={setSearch} placeholder="Buscar modelo..." />
                    <ul className="max-h-72 overflow-y-auto divide-y divide-gray-100 dark:divide-slate-700 rounded-lg border border-gray-200 dark:border-slate-700">
                        {filtered.map((t) => (
                            <li key={t.id}>
                                <button
                                    type="button"
                                    onClick={() => setSelected(t.id)}
                                    className={`w-full text-left px-3 py-2 ${selected === t.id ? 'bg-teal-50 dark:bg-teal-900/30' : 'hover:bg-slate-50 dark:hover:bg-slate-700/50'}`}
                                >
                                    <span className="block font-mono text-xs text-gray-800 dark:text-gray-100">{t.name}</span>
                                    <span className="block text-xs text-gray-500">
                                        {t.description || 'Sem descrição'} · {t.variables.length} variáveis
                                    </span>
                                </button>
                            </li>
                        ))}
                        {!filtered.length && <li className="px-3 py-4 text-sm text-gray-400">Nenhum modelo livre encontrado.</li>}
                    </ul>
                </div>
            }
            footer={
                <div className="flex justify-end gap-2">
                    <button type="button" onClick={close} className="px-4 py-2 rounded-md bg-gray-200 text-gray-800 hover:bg-gray-300 dark:bg-slate-700 dark:text-gray-100">
                        Cancelar
                    </button>
                    <button
                        type="button"
                        disabled={!selected}
                        onClick={() => {
                            if (selected) onLink(selected);
                            close();
                        }}
                        className="px-4 py-2 rounded-md bg-gray-600 text-white hover:bg-gray-700 disabled:opacity-40"
                    >
                        Vincular
                    </button>
                </div>
            }
        />
    );
};

export default LinkTemplateDialog;
